export default function HowItWorksSection() {
  const steps = [
    {
      number: '1',
      icon: 'ri-search-line',
      title: 'Recherchez votre coach',
      description: 'Parcourez notre sélection de coachs certifiés et filtrez par spécialité, localisation et tarifs pour trouver celui qui correspond à vos besoins'
    },
    {
      number: '2',
      icon: 'ri-user-heart-line',
      title: 'Consultez les profils',
      description: 'Découvrez les qualifications, expériences, avis clients et disponibilités de chaque coach pour faire le meilleur choix'
    },
    {
      number: '3',
      icon: 'ri-calendar-check-line',
      title: 'Réservez votre séance',
      description: 'Choisissez votre créneau horaire et réservez directement en ligne. Votre coach vient chez vous avec tout le matériel nécessaire'
    },
    {
      number: '4',
      icon: 'ri-trophy-line',
      title: 'Atteignez vos objectifs',
      description: 'Bénéficiez d\'un accompagnement personnalisé et suivez vos progrès pour atteindre vos objectifs fitness et bien-être'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Comment ça marche ?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Trouvez et réservez votre coach sportif en 4 étapes simples
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-1/2 w-full h-0.5 bg-blue-200 z-0" />
              )}
              
              <div className="relative z-10 text-center">
                <div className="w-32 h-32 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                  <i className={`${step.icon} text-4xl text-white`}></i>
                </div>
                
                <div className="absolute top-0 right-0 w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-xl shadow-md">
                  {step.number}
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-4">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a 
            href="/coachs"
            className="inline-block bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors shadow-lg cursor-pointer whitespace-nowrap"
          >
            <i className="ri-search-line mr-2"></i>
            Commencer maintenant
          </a>
        </div>
      </div>
    </section>
  );
}
